import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'pluralize',
  pure: false
})
export class PluralizePipe implements PipeTransform {
  transform(value: any, variants: string[]) {
    if (isNaN(+value)) {
      return value;
    }

    let numberValue = +value % 100;
    if (numberValue > 9 && numberValue < 15) {
      return `${value} ${variants[2]}`;
    }
    numberValue = numberValue % 10;
    if (numberValue === 1) {
      return `${value} ${variants[0]}`;
    } else if (numberValue > 0 && numberValue < 5) {
      return `${value} ${variants[1]}`;
    } else {
      return `${value} ${variants[2]}`;
    }
  }
}
